"use client";

import { JSX, useEffect, useMemo, useRef } from "react";
import EmbedConsent from "rivals/components/shared/EmbedConsent";
import { setData } from "rivals/shared/utils/qa";
import styles from "./TweetBlock.module.scss";
import type { Props } from "./types";

const DATA_PHILTER = "tweet-block";

function TweetBlock({ hasEmbedConsent, html }: Props): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);
  const markup = useMemo(() => ({ __html: html }), [html]);

  useEffect(() => {
    // Initialize embedded content that may have not been initialized.
    // https://developer.x.com/en/docs/x-for-websites/javascript-api/guides/scripting-loading-and-initialization
    const twttr = window.twttr;
    if (twttr && containerRef.current) {
      twttr.widgets.load(containerRef.current);
    }
  }, [html, hasEmbedConsent]);

  if (!hasEmbedConsent) {
    return <EmbedConsent />;
  }

  return (
    <div
      className={styles.container}
      dangerouslySetInnerHTML={markup}
      ref={containerRef}
      {...setData(DATA_PHILTER)}
    />
  );
}

export default TweetBlock;
